module.exports = "https://web-assets-production.autolist.com/_next/static/images/truck-angled-f203c9af9aed2ae2d60185bb976ec96a.jpg";